module.exports = __webpack_public_path__ + "static/media/food4.3a5c1b00.jpg";